import { render } from "./DocumentationList.vue?vue&type=template&id=1876ea82&scoped=true"
import script from "./DocumentationList.vue?vue&type=script&lang=js"
export * from "./DocumentationList.vue?vue&type=script&lang=js"

import "./DocumentationList.vue?vue&type=style&index=0&id=1876ea82&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1876ea82"]])

export default __exports__